<template>
  <div
    class="ancillary-option"
    :class="{ 'ancillary-option--disabled': disabled }"
    v-b-popover.hover.top="disabled ? locked_tooltip : ''"
  >
    <span class="ancillary-option__title">
      {{ title }}
      <vb-icon
        v-if="subtitle && !disabled"
        name="info"
        :size="12"
        color="AAA"
        v-b-popover.hover.right="subtitle"
      />
    </span>

    <span class="ancillary-option__price">
      <span v-if="is_included" class="ancillary-option__included">Incluso</span>
      <template v-else>
        <span class="ancillary-option__amount">{{ price_amount }}</span>
        <span class="ancillary-option__currency">{{ currency_symbol }}</span>
      </template>
    </span>
    <vb-checkbox
      @change="(value) => { if (!disabled) $emit('select') }"
      :vb_options="{
        checked: selected,
        switch: true,
        disabled: disabled,
        type: 'light',
      }"
    />
  </div>
</template>

<script>
export default {
  name: "ancillary-option",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    price_amount: { type: String, default: "" },
    currency_symbol: { type: String, default: "" },
    icon: { type: String, default: "luggage" },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    locked_tooltip: { type: String, default: "" },
  },
  computed: {
    is_included() {
      return Number(this.price_amount) === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.ancillary-option {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: left;

  &--disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-grow: 1;
    font-size: $font-size-md;
    line-height: 1;
  }

  &__price {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    font-weight: $vb-font-weight-semibold;
    color: $primary;
    font-size: $font-size-md;
    white-space: nowrap;

    @include media-breakpoint-up(md) {
      margin-top: auto;
    }
  }
}
</style>
